import React, { useEffect } from 'react';
import { Route, Routes } from 'react-router';
import { BrowserRouter as Router } from 'react-router-dom';
import { LOGOUT } from './actions/types';
import './CSS/App.css';

// Redux
import { Provider } from 'react-redux';
import store from './store';
import setAuthToken from './utils/setAuthToken';

// Private Route
import PrivateRouteAdmin from './components/routing/PrivateRouteAdmin';

// Layout
import HomeScreen from './components/homepage/HomeScreen';
import Alert from './components/layout/Alert';
import Footer from './components/layout/Footer';
import Landing from './components/layout/Landing';
import Navbar from './components/layout/Navbar';
import NotFound from './components/layout/NotFound';

// Admin
import AdminDashboard from './components/admin/AdminDashboard';
import AdminDashboardMain from './components/admin/AdminDashboardMain';
import AdminLogin from './components/auth/AdminLogin';

// Guest
import GuestLogin from './components/auth/GuestLogin';
import GuestRegister from './components/auth/GuestRegister';
import AdminGuestMain from './components/guest/AdminGuestMain';

// Booking
import AdminBookingMain from './components/booking/AdminBookingMain';
import Booking from './components/booking/Booking';
import BookRoom from './components/booking/BookRoom';

// Room
import AddRoom from './components/room/AddRoom';
import AdminRoomsMain from './components/room/AdminRoomsMain';
import AllRooms from './components/room/AllRooms';
import Room from './components/room/Room';
import VacantRooms from './components/room/VacantRooms';

// Coupon
import AddCoupon from './components/coupon/AddCoupon';
import AdminCouponsMain from './components/coupon/AdminCouponsMain';
import AllCoupons from './components/coupon/AllCoupons';
import Coupon from './components/coupon/Coupon';

//Payment
import AdminPaymentMain from './components/payment/AdminPaymentMain';
import BarPaymentMain from './components/payment/BarPaymentMain';
import BarPaymentSuccess from './components/payment/BarPaymentSuccess';
import ConferencePaymentMain from './components/payment/ConferencePaymentMain';
import ConferencePaymentSuccess from './components/payment/ConferencePaymentSuccess';
import PaymentMain from './components/payment/PaymentMain';
import PaymentSuccess from './components/payment/PaymentSuccess';

//Gallery
import AddImage from './components/gallery/AddImage';
import AdminGalleryMain from './components/gallery/AdminGalleryMain';
import AllImages from './components/gallery/AllImages';
import Gallery from './components/gallery/Gallery';

//Feedback
import AllFeedbacks from './components/feedback/AllFeedbacks';
import Feedback from './components/feedback/Feedback';

//Bar
import AddBar from './components/bar/AddBar';
import AdminBarMain from './components/bar/AdminBarMain';
import AllBarBookings from './components/bar/AllBarBookings';
import AllBars from './components/bar/AllBars';
import Bar from './components/bar/Bar';
import BarBooking from './components/bar/BarBooking';
import BookBar from './components/bar/BookBar';

//Conference
import AddConference from './components/conference/AddConference';
import AdminConferenceMain from './components/conference/AdminConferenceMain';
import AllConferenceBookings from './components/conference/AllConferenceBookings';
import AllConferences from './components/conference/AllConferences';
import BookConference from './components/conference/BookConference';
import Conference from './components/conference/Conference';
import ConferenceBooking from './components/conference/ConferenceBooking';

//Banquet
import Banquet from './components/banquet/Banquet';

const App = () => {
  useEffect(() => {
    if (localStorage.token) {
      setAuthToken(localStorage.token);
    }
    window.addEventListener('storage', () => {
      if (!localStorage.token) store.dispatch({ type: LOGOUT });
    });
  },[]);

  return (
    <Provider store={store}>
    <Router>
      <Navbar/>
      
      <Routes>
          <Route path='/' element={<Landing />} />
          <Route path="/homescreen" element={<HomeScreen />} />
          <Route path='/guestLogin' element={<GuestLogin />} />
          <Route path='/guestRegister' element={<GuestRegister />} />
          <Route path='/adminLogin' element={<AdminLogin />} />
          <Route path='/promotions' element={<Coupon/>} />
          <Route path='/rooms' element={<Room/>} />
          <Route path='/gallery' element={<Gallery/>} />
          <Route path='/bar' element={<Bar />} />
          <Route path='/banquet' element={<Banquet />} />
          <Route path='/conference' element={<Conference/>} />
          <Route path='/bookings' element={<Booking />} />
          <Route path='/barbookings' element={<BarBooking />} />
          <Route path='/conferencebookings' element={<ConferenceBooking />} />
          <Route path='/bookroom/*' element={<BookRoom />} />
          <Route path='/bookbar/*' element={<BookBar />} />
          <Route path='/bookconference/*' element={<BookConference/>} />
          <Route path='/pay/*' element={<PaymentMain/>} />
          <Route path='/barpay/*' element={<BarPaymentMain/>} />
          <Route path='/conferencepay/*' element={<ConferencePaymentMain/>} />
          <Route path='/paymentsuccess/*' element={<PaymentSuccess/>} />
          <Route path='/barpaymentsuccess/*' element={<BarPaymentSuccess/>} />
          <Route path='/conferencepaymentsuccess/*' element={<ConferencePaymentSuccess/>} />
          
          {/* ------------- Guest ------------ */}



          {/* ------------- Admin ------------ */}
          <Route path='/adminDashboard' element={
            <PrivateRouteAdmin>
              <AdminDashboard />
            </PrivateRouteAdmin>}
          >
            <Route index element={<AdminDashboardMain />} />
            <Route path='bookings' element={<Booking />} />

            <Route path='guests' element={<AdminGuestMain/>}>
              <Route index element={<AdminGuestMain/>} />
            </Route>
            
            <Route path='room' element={<AdminRoomsMain/>}>
              <Route index element={<AllRooms />} />
              <Route path='all' element={<AllRooms />} />
              <Route path='add' element={<AddRoom />} />
              <Route path='vacant' element={<VacantRooms />} />
            </Route>

            <Route path='booking' element={<AdminBookingMain/>}>
              <Route index element={<AdminBookingMain/>} />
            </Route>

            <Route path='coupons' element={<AdminCouponsMain/>}>
              <Route index element={<AllCoupons />} />
              <Route path='all' element={<AllCoupons />} />
              <Route path='add' element={<AddCoupon />} />
            </Route>

            <Route path='gallery' element={<AdminGalleryMain/>}>
              <Route index element={<AllImages />} />
              <Route path='all' element={<AllImages />} />
              <Route path='add' element={<AddImage />} />
            </Route>

            <Route path='feedbacks' element={<AllFeedbacks/>}>
              <Route index element={<AllFeedbacks/>} />
            </Route>

            <Route path='bar' element={<AdminBarMain/>}>
              <Route index element={<AllBars/>} />
              <Route path='bookings' element={<AllBarBookings/>} />
              <Route path='add' element={<AddBar/>} />
              <Route path='all' element={<AllBars/>} />
            </Route>

            <Route path='conference' element={<AdminConferenceMain/>}>
              <Route index element={<AllConferences/>} />
              <Route path='bookings' element={<AllConferenceBookings/>} />
              <Route path='add' element={<AddConference/>} />
              <Route path='all' element={<AllConferences/>} />
            </Route>

            <Route path='payments' element={<AdminPaymentMain/>}>
              <Route index element={<AdminPaymentMain/>} />
            </Route>

          </Route>
          
          <Route path="*" element={<NotFound />} />
      </Routes>
      <Alert/>
      
      <Footer/>
      <Feedback/>
    </Router>
    </Provider>
  );
}

export default App;
